export default (
  state = {
    loginUser: null,
    secondaryPermissions: [],
    secondaryPermissionsRoles: [],
    is_PWA: false
  },
  action,
) => {
  switch (action.type) {
    case 'SET_USER':
      return { ...state, loginUser: action.data };
    case 'SET_SECONDARY_PERMISSION':
      return { ...state, secondaryPermissions: action.data };
    case 'SET_SECONDARY_PERMISSION_ROLES':
      return { ...state, secondaryPermissionsRoles: action.data };
    case 'LOGOUT':
      return { ...state, loginUser: null };
    case 'SET_IS_PWA':
      return { ...state, is_PWA: action.is_PWA };
    default:
      return state;
  }
};
